import React, { useMemo } from 'react';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RequestCountCard from '../RequestCountCard/RequestCountCard';
import { getSearchParams } from '../../helpers/searchParamsFns';
import { getItems } from './helpers/getItems';
import { getChartData } from './helpers/getChartData';
import useRequestsQueryState from '../../hooks/useRequestsQueryState';
import styles from './Dashboard.module.scss';
import cn from 'classnames';

const gap = 20;

const Dashboard = () => {
  const match = useRouteMatch();

  const location = useLocation();

  const requestsState = useRequestsQueryState();

  const requestsCounts = useSelector(
    (state) => state.statisticsStore.requestsCounts
  );

  const filteredRequests = useSelector(
    (state) => state.statisticsStore.filteredRequests
  );

  const isCounting = useSelector((state) => state.statisticsStore.isCounting);

  const baseItems = useMemo(() => getItems(requestsCounts), [requestsCounts]);

  const items = useMemo(() => {
    const chartTitles = ['Всего заявок', 'Новые', 'Аварийные', 'Просроченные'];

    const baseItemsMap = baseItems.map((item) => {
      const shouldCalculateChartData = chartTitles.includes(item.title);

      const chartData = shouldCalculateChartData
        ? getChartData(item.key, filteredRequests)
        : null;

      return {
        ...item,
        chartData,
      };
    });

    return baseItemsMap;
  }, [baseItems, filteredRequests]);

  const searchParams = getSearchParams(location.search);

  return (
    <div
      className={styles.root}
      style={{ gap: `${gap}px` }}
    >
      {items.map((item, index) => (
        <div
          key={item.key}
          className={cn(styles.col, index < 4 && styles.col_big)}
          style={{
            flexBasis: `calc((100% - ${(items.length - 1) * gap}px) / ${
              items.length
            })`,
          }}
        >
          <Link
            to={{
              pathname: `${match.url}${item.link}`,
              search: `${searchParams}`,
            }}
          >
            <RequestCountCard
              title={item.title}
              requestCount={item.count}
              chartData={item.chartData}
              className={styles.requestCountCard}
              loading={requestsState?.isFetching || isCounting}
              hasLink
              description={item.description}
            />
          </Link>
        </div>
      ))}
    </div>
  );
};

export default Dashboard;
